import { createSlice } from "@reduxjs/toolkit";

/**
 * One notification at a time, carrying its own level.
 *
 * Previously this held two independent flag/message pairs (success and error),
 * which could both be true at once and had no room for the design's third
 * level. The design system's toast has success / info / danger variants, and
 * uses info for "User deactivated" and "User deleted" — actions that succeeded
 * but are not celebrations.
 */
const initialState = {
  open: false,
  message: "",
  level: "success", // success | info | error
};

const show = (level) => (state, action) => {
  state.open = true;
  state.message = action.payload;
  state.level = level;
};

export const notificationsSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    showSuccess: show("success"),
    showInfo: show("info"),
    showError: show("error"),
    hideNotification: (state) => {
      state.open = false;
      // The message is deliberately left in place so it does not blank out
      // mid-fade as the toast transitions away.
    },
  },
});

export const { showSuccess, showInfo, showError, hideNotification } = notificationsSlice.actions;

export const getIsNotificationOpen = (state) => state.notifications.open;
export const getNotificationMessage = (state) => state.notifications.message;
export const getNotificationLevel = (state) => state.notifications.level;

export default notificationsSlice.reducer;
